angular.module('submitFeedBackModule',[]).controller("submitFeedBackCtrl",
    ["$scope", "$modalInstance", "trsHttpService", "$q", 'modalDialog', 'trsspliceString','$validation','Upload',
    function($scope, $modalInstance, trsHttpService, $q, modalDialog, trsspliceString,$validation,Upload){
    initStatus()

    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            uploadData:[],
            feedBackTitle:"",
            feedBackDesc:"",
        };
        $scope.data = {

        };
    }

    /**
     * [selectFile description] 选择文件
     * @param  {[type]} $files    [description]
     * @param  {[type]} $file     [description]
     * @param  {[type]} $newFiles [description]
     * @return {[type]}           [description]
     */
    $scope.selectFile = function($files, $file, $newFiles,$index) {
        // 重传
        if($index != undefined){
            var file = $newFiles[0];
            uploadPic(file, $newFiles,$index);
            return
        }

        let residualLength = 9 - $scope.status.uploadData.length;
        if ($newFiles.length > residualLength) {
            $newFiles.splice(residualLength, $newFiles.length);
        }
        for (var i in $newFiles) {
            var file = $newFiles[i];
            uploadPic(file, $newFiles);
        }
    };
    /**
     * [delete description] 删除选中图片
     * @return {[type]} [description]
     */
    $scope.delete = function(index) {
        $scope.status.uploadData.splice(index, 1);
    };
    /**
     * [uploadPic description] 上传图片
     * @return {[type]} [description]
     */
    function uploadPic(file, $newFiles,$index) {
        let file_ = {
            type:'image'
        };
        var reader = new FileReader();
        reader.readAsDataURL(file);
        // reader.onload = function(e) {
        //     file_.imgSrc = e.target.result;
        // }
        // 重传
        if($index != undefined){
            $scope.status.uploadData[$index] = file_;
        }else{
            $scope.status.uploadData.push(file_);
        }
        
        Upload.upload({
            url: "/wcm/openapi/uploadImage",
            data: {
                file: file
            },
        }).then(function(resp) {
            delete file_.progress;
            if (resp.data.success) {
                file_.imgSrc = resp.data.imgSrc.substring(resp.data.imgSrc.indexOf("/wcm"), resp.data.imgSrc.length);
                file_.fileName = resp.data.imgName;
            } else {
                file_.error = resp.data.error;
            }
        }, function(resp) {
            delete file_.progress;
            if (resp.status == '413') {
                file_.error = '文件太大，不得大于30MB!';
            } else {
                file_.error = '未知错误!';
            }
        }, function(evt) {
            file_.progress = parseInt((evt.loaded / evt.total * 100)) + "%";
            file_.FILEINFO = "上传中";
        })
    }

    /**
     * [confirm description] 提交
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $validation.validate($scope.sumitFeedBackForm).success(function() {
            var pic = [],video = [];
            $scope.status.uploadData.map((item,index)=>{
                if(item.type == 'image'){
                    pic.push(item)
                }else{
                    video.push(item)
                }
            })
            var picNameStr = trsspliceString.spliceString(pic, "fileName", ",");
            var videoNameStr = trsspliceString.spliceString(video, "fileName", ",");
			$scope.params = {
				serviceid: "mlf_feedback",
                methodname: 'saveFeedBack',
                FEEDBACKID:0,
                title: $scope.status.feedBackTitle,
                content: $scope.status.feedBackDesc,
                pics: picNameStr,
                videos:videoNameStr,
            }
			trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(res) {
                if(res.ISSUCCESS == 'true'){
                    modalDialog.saveModel("保存成功" ,'', "success");
                    $scope.cancel()
                }else{
                    modalDialog.saveModel("保存失败" ,'', "error");
                }
                
            });
        }).error(function() {
            modalDialog.saveModel("保存失败", "请检查填写项", "error");
        });
    }

    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.close('cancel');
    };
}]);